import CustomDatePicker from './picker/date-picker';

/**
 * @description: 自定义时间控件
 * 基于iView-DatePicker
 *
 * 添加如下自定义功能：
 *   1.静态时间：返回 {from: String, to: String}
 *   2.动态时间：返回 {
 *                    unit: String,
 *                    range: undefined || [Number, Number],
 *                    time: Object | {from: String, to: String}
 *                  }
 *   3.选择两个时间范围: [{from：String, to：String}, {from：String, to：String}]
 *
 * 添加属性：
 *   width | Number: 时间控件宽度设置
 *   compareDate | Boolean: 是否开启对比日期功能
 *   editTime | Boolean：选择时间按钮显示,按 小时 / 分钟 查看数据的时候需要显示，动态时间不显示
 *   staticOnly | Boolean：只显示静态时间
 *   dateRes | Object: 预设的时间对象，在编辑和缓存中生效
 *      |__viewDate | Array：时间控件显示的日期
 *      |__compared | Object：对比日期对象
 *      |__isDynamic | Boolean：是否选择的动态时间
 *      |__term | String：对比日期范围类型：自定义、上一时段、去年同期
 *
 */
export default CustomDatePicker;



// WEBPACK FOOTER //
// ./src/views/my-components/custom-date-picker/index.js